module.exports = __webpack_public_path__ + "static/media/booth-bottom.86d68f7a.png";